var debounce = require("lodash/debounce");

import { ADDITIONAL_TOP_SPACING } from "./constants";

/**
 * @function
 * @description - Scroll to element
 * @param {Element} $element - Element to be scrolled in view
 * @param {String, Integer} speed - Animation speed
 * @param {Object} $container - Container to be scrolled in
 */
function scrollToElement($element, speed, $container = $("html, body"), extraOffset = 0) {
    var stickyNavHeight = 0,
        $stickyElements = $(".sticky-element");

    $stickyElements.each(function () {
        stickyNavHeight += $(this).height();
    });

    $container.animate({
        scrollTop: $element.offset().top - stickyNavHeight - extraOffset
    }, speed);
}

/**
 * Scroll input into view, above the sticky summary
 * @param {Element} input - Input element to be scrolled
 */
const scrollInputFieldIntoView = debounce((input) => {
    const headerHeight = document.querySelector(".header").offsetHeight;

    // Scroll page in order to bring input above sticky summary
    $("html, body").animate({scrollTop: $(input).offset().top - (headerHeight + ADDITIONAL_TOP_SPACING)}, 0);
}, 300);

export { scrollToElement, scrollInputFieldIntoView };
